import { LOAD_MEDIA_INFO } from './actions'

export const mediaInfo = (state = {}, { type, ...action}) => {
    switch (type)
    {
        case LOAD_MEDIA_INFO:
            const { mediaInfo, groupPosition, mediaPosition } = action

            const newState = {}
            newState[groupPosition] = {}
            if(state[groupPosition])
            {
                newState[groupPosition] = {...state[groupPosition]}
            }
            newState[groupPosition][mediaPosition] = {...mediaInfo}

            return {
                ...state,
                ...newState,
            }
        default:
            return state
    }
}
